import { get } from '@/utils/request'

export const getPostSignatureForOssUpload = () => get('/file/getPostSignatureForOssUpload')

